/* ============================================================
   DATA JMC SKINCARE

   Letakkan di: app/layanan/jmc-skincare/jmc-skincare.js

   ============================================================
   ⚠️⚠️ DUA HAL YANG MEMBEDAKAN LAYANAN INI DARI SEMUA YANG LAIN

   1. ALAMATNYA BUKAN DI GEDUNG RUMAH SAKIT.

      Poster menyebut "Lantai 6 Suite Room", bukan Jl. Warung
      Buncit Raya No. 15. Empat belas layanan lain di situs ini berada
      di gedung RS; yang ini tidak.

      Itu keterangan paling penting di seluruh halaman, dan di situs
      lama ia hanya tertulis DI DALAM GAMBAR - tidak terbaca pembaca
      layar, tidak terbaca mesin pencari, dan tidak terbaca siapa pun
      yang gambarnya gagal dimuat.

      Akibatnya nyata: orang datang ke rumah sakit, lalu diberi tahu
      bahwa tempatnya di gedung lain.

   2. NOMORNYA BUKAN NOMOR RUMAH SAKIT.

      0851-6886-7636 adalah nomor Customer Service JMC Skincare
      sendiri. Nomor CS rumah sakit (0811-901-874) dan nomor hunting
      TIDAK dicantumkan di halaman lama - dan saya tidak
      menambahkannya, karena petugas di sana kemungkinan besar tidak
      memegang jadwal maupun harga skincare.

   ============================================================
   SUMBER ISINYA

   Nomor, kalimat pengantar, dan nama gedung disalin dari halaman lama
   di rsjmc.id/jmc-skincare beserta posternya.

   Kalimat pengantarnya diambil dari layananList.skincareDesc di
   dictionary.js.
   ============================================================ */

/* ============================================================
   LOKASI

   ⚠️ ALAMAT LENGKAPNYA BELUM DIISI. Poster hanya menyebut nama
   gedungnya, dan saya tidak tahu alamat jalannya.

   Isi `alamat` dengan alamat lengkap, lalu isi `cari` dengan teks
   pencarian untuk Google Maps - biasanya nama gedung ditambah
   alamatnya. Contoh bentuknya bisa dilihat di
   app/layanan/igd/igd.js.

   Selama `alamat` kosong, halaman hanya menampilkan nama gedungnya
   tanpa tombol peta. Itu sudah jauh lebih baik daripada situs lama
   yang tidak menyebutkannya sama sekali di luar gambar - tapi belum
   cukup untuk orang yang harus sampai ke sana.

   PRIORITASKAN INI. Dari seluruh hal yang belum lengkap di halaman
   ini, alamat adalah yang paling mahal akibatnya kalau dibiarkan:
   pasien yang tersasar ke gedung rumah sakit kehilangan waktu, dan
   sebagian tidak kembali.
   ============================================================ */
export const LOKASI = {
  gedung: { id: "Lantai 6 Suite Room", en: "Suite Room – 6th Floor" },
  alamat: { id: "", en: "" },
  cari: "",
};

/* ============================================================
   POSTER - SEKARANG DUA LEMBAR, BUKAN SATU

   ============================================================
   KENAPA DIPECAH

   Poster lamanya satu lembar roll-up dengan perbandingan sekitar
   1 : 2,9 - dibuat untuk dicetak setinggi orang dewasa, bukan untuk
   dibaca di halaman web.

   Di halaman ini akibatnya terlihat jelas: gambarnya dipaksa masuk
   kolom selebar 520px, jadi tingginya melebihi 1500px. Kolom kiri
   selesai di sepertiga tinggi halaman sementara kolom kanan terus
   memanjang, menyisakan bidang kosong besar di kiri-bawah. Dan
   karena diperkecil sebanyak itu, tulisan "Hifu", "Laser", serta
   seluruh daftar fasilitasnya tidak terbaca tanpa diperbesar.

   Sekarang isinya dipecah jadi dua lembar berperbandingan 4:5:

     lembar 1  perawatan unggulan - foto, alamat, WhatsApp,
               HIFU / Laser / IPL & RF
     lembar 2  daftar fasilitas lengkap dan baris kontak

   Masing-masing dipasang di bagian halaman yang isinya sesuai -
   lihat JmcSkincareContent.jsx. Tidak ada lembar yang ditampilkan
   dua kali.

   ============================================================
   ⚠️ PERIKSA NAMA DAN EKSTENSI BERKASNYA

   Simpan kedua gambar di public/images/. Yang tertulis di `src`
   harus SAMA PERSIS dengan nama berkas di disk, termasuk huruf
   besar-kecilnya. Windows tidak membedakan, server produksi
   membedakan.

   Kalau salah satu salah, halaman tidak rusak - lembar itu saja yang
   disembunyikan sendiri, yang lain tetap tampil.

   ============================================================
   ⚠️ POSTERNYA MEMUAT WAJAH SESEORANG

   Pastikan yang bersangkutan memberi izin fotonya dipakai di situs
   publik. Untuk poster perawatan estetika, izin itu lebih penting
   lagi daripada biasanya - foto wajah di samping daftar perawatan
   mudah disalahartikan sebagai hasil perawatan tersebut.

   Fotonya foto stok. Periksa juga bahwa lisensinya mencakup
   pemakaian di situs, bukan hanya cetak.
   ============================================================ */
export const POSTER = [
  {
    src: "/images/skincaree.png",
    lebar: 1080,
    tinggi: 1350,
    judul: { id: "Perawatan Unggulan", en: "Featured Treatments" },
    alt: {
      id: "Poster JMC Skincare lembar pertama: alamat Lantai 6 Suite Room, nomor WhatsApp 0851-6886-7636, serta perawatan HIFU, Laser, dan IPL & RF beserta keterangannya.",
      en: "JMC Skincare poster, first sheet: the Suite Room – 6th Floor address, the WhatsApp number 0851-6886-7636, and the HIFU, Laser and IPL & RF treatments with their descriptions.",
    },
  },
  {
    src: "/images/skincare2.png",
    lebar: 1080,
    tinggi: 1350,
    judul: { id: "Daftar Fasilitas", en: "Facilities List" },
    alt: {
      id: "Poster JMC Skincare lembar kedua: daftar lengkap fasilitas dan perawatan, alamat, nomor WhatsApp, dan akun media sosial.",
      en: "JMC Skincare poster, second sheet: the full list of facilities and treatments, the address, the WhatsApp number and the social media accounts.",
    },
  },
];

export const SKINCARE = {
  telepon: [
    {
      label: { id: "Customer Service JMC Skincare", en: "JMC Skincare Customer Service" },
      tampil: "0851-6886-7636",
      tel: "+6285168867636",
      wa: "6285168867636",
      pesanWa: {
        id: "Halo JMC Skincare,\n\nSaya ingin menanyakan informasi mengenai perawatan yang tersedia beserta jadwal dan biayanya.\n\nTerima kasih.",
        en: "Hello JMC Skincare,\n\nI would like to ask about the treatments you offer, along with the schedule and pricing.\n\nThank you.",
      },
      utama: true,
    },
  ],
};

export const PERAWATAN = [
  {
    nama: { id: "HIFU", en: "HIFU" },
    isi: {
      id: "Tindakan non-bedah yang mengarahkan gelombang ultrasound terfokus ke lapisan bawah kulit untuk merangsang pembentukan kolagen.",
      en: "A non-surgical procedure that directs focused ultrasound at the deeper layers of the skin to stimulate collagen production.",
    },
  },
  {
    nama: { id: "Laser", en: "Laser" },
    isi: {
      id: "Perawatan kulit menggunakan sinar laser untuk menangani permasalahan pada permukaan kulit. Jenis laser dan jumlah sesinya ditentukan setelah konsultasi.",
      en: "Skin treatment using laser light to address concerns on the skin surface. The type of laser and number of sessions are decided after a consultation.",
    },
  },
  {
    nama: { id: "IPL & RF", en: "IPL & RF" },
    isi: {
      id: "IPL memakai cahaya berspektrum lebar, RF memakai gelombang radio. Keduanya tindakan non-bedah yang ditujukan pada warna, tekstur, dan kekencangan kulit.",
      en: "IPL uses broad-spectrum light and RF uses radio waves. Both are non-surgical procedures aimed at skin tone, texture and firmness.",
    },
  },
];

export const CATATAN_PERAWATAN = {
  id: "Hasil setiap orang berbeda. Jenis perawatan yang sesuai ditentukan setelah konsultasi.",
  en: "Results vary from person to person. The right treatment is determined after a consultation.",
};

export const FASILITAS = [
  { id: "Laser", en: "Laser" },
  { id: "Microdermabrasi", en: "Microdermabrasion" },
  { id: "IPL, HIFU, RF", en: "IPL, HIFU, RF" },
  { id: "Dermapen", en: "Dermapen" },
  { id: "Facial", en: "Facial" },
  { id: "Face Light", en: "Face Light" },
  { id: "Peeling", en: "Peeling" },
  { id: "Facial Acne", en: "Acne Facial" },
  { id: "Totok Wajah", en: "Facial Massage (Totok Wajah)" },
  { id: "Body Cavitation", en: "Body Cavitation" },
  { id: "Jet Peel", en: "Jet Peel" },
  { id: "Whitening", en: "Whitening" },
  { id: "Creambath / Hairwash", en: "Creambath / Hairwash" },
  { id: "Manicure / Pedicure", en: "Manicure / Pedicure" },
  { id: "Nano Slimming, Cavitasi", en: "Nano Slimming, Cavitation" },
  { id: "Facial Glowing", en: "Glowing Facial" },
  { id: "Hand & Foot Care", en: "Hand & Foot Care" },
  { id: "Electroporation LLT (Low Light Therapy)", en: "Electroporation LLT (Low Light Therapy)" },
  { id: "Radiofrequency for Body", en: "Radiofrequency for Body" },
  { id: "Facial Biocos", en: "Biocos Facial" },
];

/* Kalimat penutup daftar, dari poster. */
export const FASILITAS_PENUTUP = {
  id: "dan lain sebagainya - tanyakan ke Customer Service untuk perawatan yang tidak tercantum.",
  en: "and more - ask customer service about treatments not listed here.",
};

export const KETENTUAN = [];
